import React from "react";
import * as R from "ramda";
import { Link } from "react-router-dom";

import EntityTooltip from "@arachnys/styleguide/EntityTooltip";
import { formatDatetimeString } from "../formatters";

const NameTooltip = props => {
    let {
        row: {
            original: { node: entity },
        },
    } = props;

    if (entity.entity) {
        entity = entity.entity;
    }

    const ulid = R.pathOr("", ["key", "ulid"], entity);
    const tooltipData = {
        name: entity.name || "",
        ulid,
        properties: {
            Type: entity.entityType,
            "Entity ID": ulid || "Not available",
            "Date Created": formatDatetimeString({ str: entity.createdDate }),
            Status: entity.registrationStatus,
            Country: R.pathOr("", ["legalAddress", "countryCode"], entity),
            "Risk Level": entity.riskLevel,
            "Screening Level": entity.monitoring,
        },
    };
    return <EntityTooltip entity={tooltipData} />;
};

export const EntityNameTooltip = withTooltip => row => {
    const ulid = R.pathOr("", ["row", "entityULID"], row);

    return withTooltip ? (
        <React.Fragment>
            <NameTooltip row={row} />
            <span> {row.value}</span>
        </React.Fragment>
    ) : (
        <Link to={`/entities/${ulid}/`}>{row.value}</Link>
    );
};
